<!-- @format -->

<template>
  <KeepAlive>
    <component :is="page"></component>
  </KeepAlive>
</template>
<script setup>
import { computed, toValue } from 'vue'
let props = defineProps({
  currentItem: [Number, Object],
  pages: Array,
})
// const set = new Set();
// const transitionName = ref(null);
const page = computed(() => {
  let index = toValue(props.currentItem)
  // if (!set.has(index)) {
  //   transitionName.value = "slide-fade";
  //   set.add(index);
  //   console.log("anim", index);
  // } else {
  //   transitionName.value = "";
  // }
  return props.pages[index]
})
</script>
<style scoped>
.slide-fade-leave-active {
  transition: all 0.3s ease-out;
}
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
  transform: translateX(0);
}

.slide-fade-enter-from {
  transform: translateX(100%);
}
.slide-fade-leave-from {
  transform: translateX(0);
}
</style>
